import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { BestCustomer } from '../dto/BestCustomer.model';
import { ReportHeaderComponent } from '../../components/report-header/report-header.component';
import { SaleService } from '../../../../services/sale.service';

@Component({
  selector: 'app-best-customers',
  imports: [
    CommonModule,
    PaginatorModule,
    TableModule,
    ReportHeaderComponent

  ],
  templateUrl: './best-customers.component.html'
})
export class BestCustomersComponent {

  constructor(private saleService: SaleService ){

  }

  items: BestCustomer[] = [];
  loading: boolean = true;
  first: number = 1;
  rows: number = 0
  totalRecords: number = 0;
  currentPage: number = 1;

  currentDate = new Date();
  initialDate: Date = this.currentDate;
  finalDate: Date = this.currentDate;

  onDateChange = (dates: { initialDate: Date; finalDate: Date }) => {
      this.initialDate = dates.initialDate;
      this.finalDate = dates.finalDate;
  }

  onPageChange = (event: any) => {
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

    getData =() => {
    this.loading = true;
      this.saleService.getBestCustomers(this.initialDate, this.finalDate, this.currentPage).subscribe({
        next: (data) => {
          this.items = data.data;
          this.totalRecords = data.pagination.totalRecords;
          this.loading = false;
        },
        error: (error) => {
          console.log(error);
          this.loading = false;
        }
      });
    }


  export = () => {
    this.saleService.exportBestCustomers(this.initialDate, this.finalDate).subscribe({
      next: (file) => {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

}
